import type { SVGProps } from 'react';

interface TrashIconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const TrashIcon = ({
  fillColor = 'currentColor',
  width = 14,
  height = 16,
  className = '',
  ...props
}: TrashIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        d='M2.58 15.68C2.107 15.68 1.70208 15.5094 1.36525 15.1682C1.02842 14.827 0.86 14.4169 0.86 13.9378V2.61333H0V0.871111H4.3V0H9.46V0.871111H13.76V2.61333H12.9V13.9378C12.9 14.4169 12.7316 14.827 12.3947 15.1682C12.0579 15.5094 11.653 15.68 11.18 15.68H2.58ZM11.18 2.61333H2.58V13.9378H11.18V2.61333ZM4.3 12.1956H6.02V4.35556H4.3V12.1956ZM7.74 12.1956H9.46V4.35556H7.74V12.1956Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default TrashIcon;
